import axios from 'axios';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from "../../../../Models/Utilisateur";
import { useState } from "react";
import { Button, Form, Tabs, Space, Spin, Table } from 'antd';
import type { TabsProps } from 'antd';
import Demand from '../../../../Models/MMontantBloquer';
import { Box, Typography } from '@mui/material';
import SweetAlert from "sweetalert2";
import InputForm from "../../../InputT";
import SearchModal from "../../../SearchModal";
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import ParamsPicklist from "../../../../Types/ParamsPicklist"
import Tab1 from './Tab1';
import SearInputG from "../../../SearchInput"
import Data from '../../../../Data/Data.json'
import { Radio } from 'antd';


//pour le tableau
import DataType from "../../../../Functions/Traitement/DataPeriodMVirement";
import { ColumnGroupType, ColumnsType } from 'antd/es/table';
import { Crypter } from "../../../../Functions/Security/Crypter";
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import formatDate from '../../../../Functions/Traitement/fomatDate';
import RadioBox from "../../../Radiox";



const OpposeVP = () => {
    const [state, setstate] = useState(false)
    const [Lim, setlim] = useState('aba')
    // usestate pour remplir le tableau
    const [donnees, setData] = useState<DataType[]>([]);
    const [SearchR, SetSearchR] = useState<string>("");


    //column du tableau
    const columns: ColumnsType<DataType> = [
        {
            title: 'NUMDOS',
            dataIndex: 'NUMDOS',
            filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.NUMDOS)
                    .toLowerCase()
                    .includes(value.toLowerCase()) ||
                    String(record.CPTDEB)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.CPTCRE)
                        .toLowerCase()
                        .includes(value.toLowerCase())
            }
        },
        {
            title: 'CPTDEB',
            dataIndex: 'CPTDEB',
        },
        {
            title: 'CPTCRE',
            dataIndex: 'CPTCRE',
        },
        {
            title: 'MONTAN',
            dataIndex: 'MONTAN',
        },
        {
            title: 'cdetat',
            dataIndex: 'cdetat',
        },
        {
            title: 'UTISAI',
            dataIndex: 'UTISAI',
        },
        {
            title: 'codage',
            dataIndex: 'codage',
        },{
            title: 'DATSAI',
            dataIndex: 'DATSAI',
        },{
            title: 'DATIMP',
            dataIndex: 'DATIMP',
        },{
            title: 'DATARRIMP',
            dataIndex: 'DATARRIMP',
        },
        //STACHQ

    ];


    // USER SESSION
    const [form] = Form.useForm();
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false)
    const [ajoutActve, setAjoutActif] = useState(false)
    const [sbmit, setSbmit] = useState("")
    const [Impot, setImpot] = useState(false)

    const authHeader = useAuthHeader()


    // Handle pour la selection des element dans le tableau
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    // function pour la selection du tab
    const onSelectChange = (newSelectedRowKeys: any) => {
        console.log('selectedRowKeys changed :) ', donnees[newSelectedRowKeys]);
        setSelectedRowKeys(newSelectedRowKeys);
        //sessionStorage.setItem(Data.LocalVariable.FourthValueAuto, Crypter.encrypt(donnees[newSelectedRowKeys].REFMARQ))
        sessionStorage.clear();
        sessionStorage.setItem(Data.LocalVariable.FirstValueAuto, Crypter.encrypt(donnees[newSelectedRowKeys].NUMDOS))
    };

    const rowSelection = {
        onChange: onSelectChange,
        selectedRowKeys,
    };

    const [checkboxValues, setCheckboxValues] = useState({
        checkbox1: false,
        checkbox2: false,
        checkbox3: false,
    });
    function handleCheckboxChange(events = require('events')) {
        const { name, checked } = events.target;
        setCheckboxValues({ ...checkboxValues, [name]: checked });
    }


    // usestate 
    function handleAnnul() {
        setSelectedRowKeys([]);
    }

    // Gestion des Items 
    const items: TabsProps['items'] = [
        {
            key: '2',
            label: (
                <span id='Tab'>
                    <UserOutlined />
                    Opposition / Retablir Vp
                </span>
            ),
            children: <Tab1 />, //form={form}
        },
    ];

    // function Handle

    function HandleAnnul() {

        form.resetFields();
        setSelectedRowKeys([]);
        setImpot(false);
        setData([]);
    }

    function HandleOppose() {

        Consultableau();
        setSelectedRowKeys([]);
    }


    // function consult tableableau
    function Consultableau() {
        setSelectedRowKeys([]);
        let a = Perss.codage;
        let b = '6';

        setLoading(true)
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.AllVirementPerme,
            headers: {
                'CypherCodeage': Crypter.encrypt(a),
                'CypherTrie': Crypter.encrypt(b),
                'Authorization': authHeader(),
                'Content-Type': 'application/json',
            },
        };

        // MAPPING DANS LE TABLEAU
        let dat: DataType[] = [];
        axios.request(config)
            .then((response) => {
                setLoading(false);

                if (response.data) {
                    let datas = JSON.parse(JSON.stringify((response.data.Result)));
                    if (datas[0] == null) {
                        SweetAlert.fire({ title: "Il ne possède pas de Vp Valide ou bloquer ", icon: "warning" })
                    } else {

                    }

                    datas.map((val: any, key: any) => {
                        dat.push({
                            key: key,
                            NUMDOS: val.NUMDOS,
                            CODOPE: val.CODOPE,
                            DATSAI: val.DATSAI,
                            DATIMP: val.DATIMP,
                            CPTDEB: val.CPTDEB,
                            LIBCPTDEB: val.LIBCPTDEB,
                            CPTCRE: val.CPTCRE,
                            LIBCPTCRE: val.LIBCPTCRE,
                            MONTAN: val.MONTAN,
                            FREQIMP: val.FREQIMP,
                            NBRIMP: val.NBRIMP,
                            DECOUV: val.DECOUV,
                            DATARRIMP: val.DATARRIMP,
                            UTISAI: val.UTISAI,
                            UTIMOD: val.UTIMOD,
                            DATMOD: val.DATMOD,
                            IsFRAIS: val.IsFRAIS,
                            MONTAN1: val.MONTAN1,
                            MONTAN2: val.MONTAN2,
                            MONTAN3: val.MONTAN3,
                            MONTAN4: val.MONTAN4,
                            LIBELL1: val.LIBELL1,
                            LIBELL2: val.LIBELL2,
                            LIBELL3: val.LIBELL3,
                            LIBELL4: val.LIBELL4,
                            CODOP1: val.CODOP1,
                            CODOP2: val.CODOP2,
                            CODOP3: val.CODOP3,
                            CODOP4: val.CODOP4,
                            codage: val.codage,
                            cdetat: val.cdetat,
                            utival: val.utival,
                            isbloqAuto: val.isbloqAuto,
                            datval: val.datval
                        })
                    })
                    setData((dat))
                } else {
                    SweetAlert.fire({ title: "Error", text: "Aucun Element dans le tableau", icon: "warning" })
                }
                setLoading(false)
            })
            .catch((error) => {
                setLoading(false);
                SweetAlert.fire({ title: "Error", text: error, icon: "error" })
            });

    }

    // function Onfinish
    const onFinish = (values: any) => {
        if (selectedRowKeys.length == 0) {
            SweetAlert.fire({ title: " selectionner un Vp", text: "", icon: "warning" })
        } else {

            if (sbmit == 'Oppose') {
                let NUMDOS = (((sessionStorage.getItem(Data.LocalVariable.FirstValueAuto) + '')) + "")
                //alert(NUMDEMANDE);
                let data2 = Crypter.encrypt(Perss.coduti)
                let data3 = Crypter.encrypt(Perss.datjour)
                let data4 = Crypter.encrypt(Perss.codage)
                let data5 = Crypter.encrypt('5')


                SweetAlert.fire({
                    title: "Valider VP",
                    text: "Voulez-vous Opposer le Vp du dossier N°: " + (Crypter.decrypt((sessionStorage.getItem(Data.LocalVariable.FirstValueAuto) + '')) + "") + " ?",
                    showCancelButton: true,
                    color: "#116599",
                    confirmButtonText: "Yes",
                    confirmButtonColor: "#116599",
                    cancelButtonColor: "darkred",
                    cancelButtonText: "No",
                    showLoaderOnConfirm: true,
                    icon: 'question'
                }).then((res) => {
                    if (res.isConfirmed) {
                        setLoading(true);
                        setIsSubmit(true)
                        let config = {
                            method: 'put',
                            maxBodyLength: Infinity,
                            url: Data.ApiUrl.ValidInvalidVirementPerme,
                            headers: {
                                'CypherNUMDOS': NUMDOS,
                                'CypherUTIVAL': data2,
                                'CypherDATVAL': data3,
                                'Cyphercodeage': data4,
                                'Cyphertrie': data5,
                                'Authorization': authHeader(),
                                'Content-Type': 'application/json'
                            },
                        };

                        axios.request(config)
                            .then((response) => {
                                setLoading(false);
                                if (response.data) {
                                    const res = JSON.parse(Crypter.decrypt(response.data));
                                    //console.log(res)    Ovalide
                                    //console.log(res)
                                    let code = res.Message
                                    if (code == 'ErrorUser') {
                                        SweetAlert.fire({ title: " ", text: "le même User ne peut Opposer le Vp", icon: "warning" })
                                    } else if (code == 'Ovalide') {
                                        SweetAlert.fire({ title: " ", text: "Vp déjà Opposer ", icon: "warning" })
                                    } else {
                                        setIsSubmit(false)
                                        SweetAlert.fire({ title: " ", text: "Vp Opposer N°:" + code, icon: "success" })
                                        localStorage.clear()
                                        form.resetFields()
                                        //HandleActualiser()
                                    }
                                    setSelectedRowKeys([]);
                                    Consultableau();
                                }
                            })
                            .catch((error) => {
                                setLoading(false);
                                SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                            });
                    }
                })
            } else if (sbmit == "Retablir") {
                let NUMDOS = (((sessionStorage.getItem(Data.LocalVariable.FirstValueAuto) + '')) + "")
                //alert(NUMDEMANDE);
                let data2 = Crypter.encrypt(Perss.coduti)
                let data3 = Crypter.encrypt(Perss.datjour)
                let data4 = Crypter.encrypt(Perss.codage)
                let data5 = Crypter.encrypt('2')


                SweetAlert.fire({
                    title: "Retablir VP",
                    text: "Voulez-vous Retablir le Vp du dossier N°: " + (Crypter.decrypt((sessionStorage.getItem(Data.LocalVariable.FirstValueAuto) + '')) + "") + " ?",
                    showCancelButton: true,
                    color: "#116599",
                    confirmButtonText: "Yes",
                    confirmButtonColor: "#116599",
                    cancelButtonColor: "darkred",
                    cancelButtonText: "No",
                    showLoaderOnConfirm: true,
                    icon: 'question'
                }).then((res) => {
                    if (res.isConfirmed) {
                        setLoading(true);
                        setIsSubmit(true)
                        let config = {
                            method: 'put',
                            maxBodyLength: Infinity,
                            url: Data.ApiUrl.ValidInvalidVirementPerme,
                            headers: {
                                'CypherNUMDOS': NUMDOS,
                                'CypherUTIVAL': data2,
                                'CypherDATVAL': data3,
                                'Cyphercodeage': data4,
                                'Cyphertrie': data5,
                                'Authorization': authHeader(),
                                'Content-Type': 'application/json'
                            },
                        };

                        axios.request(config)
                            .then((response) => {
                                setLoading(false);
                                if (response.data) {
                                    const res = JSON.parse(Crypter.decrypt(response.data));
                                    //console.log(res)    Ovalide
                                    //console.log(res)
                                    let code = res.Message
                                    if (code == 'ErrorUser') {
                                        SweetAlert.fire({ title: " ", text: "le même User ne peut Retablir le Vp", icon: "warning" })
                                    } else if (code == 'Ovalide') {
                                        SweetAlert.fire({ title: " ", text: "Vp déjà Retablir ", icon: "warning" })
                                    } else {
                                        setIsSubmit(false)
                                        SweetAlert.fire({ title: " ", text: "Vp Retablie N°:" + code, icon: "success" })
                                        localStorage.clear()
                                        form.resetFields()
                                        //HandleActualiser()
                                    }
                                    setSelectedRowKeys([]);
                                    Consultableau();
                                }
                            })
                            .catch((error) => {
                                setLoading(false);
                                SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                            });
                    }
                })
            }
        }
    }



    // control du forms 
    const onFinishFailed = (errorInfo: any) => {
        setLoading(true);
        setLoading(false);
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            SweetAlert.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };
    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b> opposition / Retablir Vp : {window.location.pathname.toUpperCase()}</b></Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
                <Form disabled={ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { Consultableau() }} type="ghost" block>
                                    Afficher
                                </Button>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { setSbmit('Oppose') }} type="ghost" htmlType='submit' block  >
                                    Opposer
                                </Button>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { setSbmit('Retablir') }} type="ghost" htmlType='submit' block  >
                                    Retablir
                                </Button>

                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>
                            <div className='tabItem' >
                                <div style={{ display: 'block flow' }}  >
                                    <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >
                                        <Box fontStyle="inherit" className='border-left '>
                                            <legend> Opposer / Retablir un Ordre de Virement Permanent </legend>
                                            <Box style={{ width: 600 }}  >
                                                <InputForm disabled={false} notRequired onChange={(e: any) => { SetSearchR(e.target.value.trim()); }} label={'recherche'} name="Element" type="string" taille={500} />
                                            </Box> 
                                        </Box>
                                        <Box fontStyle="inherit" className='border-left '>
                                            <Spin spinning={loading}>
                                                <Table dataSource={donnees} rowSelection={{ ...rowSelection, type: "radio", getCheckboxProps: (reccord) => ({ disabled: false }) }} columns={columns} style={{ width: '100%' }} scroll={{ y: 8000, x: 20 }} pagination={false} />
                                            </Spin>
                                        </Box>
                                    </Box>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}



export default OpposeVP;